/**
 * A lean score (-10..+10) as a percentage along the gauge track.
 *
 * Lifted out of LeanGauge so it can be tested without mounting framer-motion,
 * and given a defined answer for input that isn't a number. It used to be an
 * inline Math.max(0, Math.min(100, …)) chain, which propagates NaN straight
 * through — a report with a null score rendered `x: "NaN%"` on the marker.
 * Centre is the honest answer for "no reading", and it is where the marker
 * starts from anyway.
 */
export function pct(score) {
  const n = Number(score);
  if (!Number.isFinite(n)) return 50;
  return Math.max(0, Math.min(100, ((n + 10) / 20) * 100));
}
